import { render } from "./main-product.vue?vue&type=template&id=fcb65464"
import script from "./main-product.vue?vue&type=script&lang=js"
export * from "./main-product.vue?vue&type=script&lang=js"

import "./main-product.vue?vue&type=style&index=0&id=fcb65464&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__